module.exports = __webpack_public_path__ + "img/orange_048.d5e6da5b.png";